import { EnumPersonaGiuridicaDTOStatoAccreditamento } from '@framework/api-client';
import type { PersonaGiuridicaDTO } from '@framework/api-client';
import { useCurrentUser } from '@framework/auth';
import { useMemo } from 'react';

const EMPTY_LEGAL_ENTITIES: PersonaGiuridicaDTO[] = [];

/**
 * Restituisce le persone giuridiche utilizzabili (accreditamento VALIDATA) tra
 * quelle di cui l'utente corrente è operatore. Alimentano la schermata di
 * scelta "Accedi come" per lo SPID tipo 3 (persona fisica con PG associate).
 * Per lo SPID Professionale (tipo 4) la PG è pre-selezionata dal backend,
 * quindi quella schermata non viene mostrata.
 */
export function useLegalEntitySelection() {
  const currentUser = useCurrentUser();
  const user = currentUser?.utenteLoggato;

  const legalEntities =
    user?.personeGiuridicheOperatore ?? EMPTY_LEGAL_ENTITIES;
  const usableLegalEntities = useMemo(
    () => legalEntities.filter(isLegalEntityUsable),
    [legalEntities],
  );

  return { usableLegalEntities };
}

function isLegalEntityUsable(entity: PersonaGiuridicaDTO) {
  return (
    entity.statoAccreditamento ===
    EnumPersonaGiuridicaDTOStatoAccreditamento.VALIDATA
  );
}
